export const thirdSnapshot = {
  date: "2025-12-28",
  description: "Interactive",
  hash: "7de4557",

  hero: {
    name: "Sebastian Wu",
    subtitle: "Grade 11 IB Student @ MHS",
    status: "Available for Opportunities"
  },

  aboutSections: [
    {
      title: "Who I Am",
      content: "I'm a Grade 11 IB (International Baccalaureate 🤕) student at Merivale High School in Ottawa with a passion for technology and problem-solving. You'll usually find me cubing, writing, doing homework, watching youtube, or coding!"
    },
    {
      title: "Interests",
      content: "Speedcubing, Problem Solving, Math, Studio Ghibli, Photography and Creative Writing"
    },
    {
      title: "Currently",
      content: "Building web applications with React (this website!), learning rubik's cube algorithms (COLL), exploring new things."
    }
  ],

  skills: [
    {
      name: "Python",
      level: "Proficiebnt"
    },
    {
      name: "React",
      level: "Proficient"
    },
    {
      name: "HTML",
      level: "Proficient"
    },
    {
      name: "CSS",
      level: "Proficient"
    },
    {
      name: "Javascript",
      level: "Proficient"
    },
  ],

  features: {
    photography: true,
    cubing: true,
    guestbook: true,
    blog: true,
    navigation: true,
    konami: true,
    timeTravel: true,
    music: true,
    weather: true,
    clock: true,
    resume: true, 
  },

  styling: {
    hasBackgroundImage: true,
    cardOpacity: 0.8,
    borderRadius: "24px"
  }
};